<mat-form-field [style.width]="width" class="virtual-list" [ngClass]="class" floatLabel="never">
  <input matInput tabindex="-1" #ctrlInput
    (focus)="setIsSearchingValue()" (click)="getRealSelectedValue() ; " (keyup)="updateFilterList(ctrlInput.value)" [formControl]="receivingLabListCtrl" placeholder="{{(submittedNumber === 0) ? placeholder : 'Receiving Lab(s) - ' + submittedNumber}}">
  </mat-form-field>
  <input type="text" autofocus="autofocus" style="display:none" />
  @if (isSearching) {
    <div class="autocomplete" [style.width]="(width) ? width + 'vw' : autoCompleteWidth?.width +'px'"
      [style.top.px]="autoCompleteWidth?.top + 50">
      <cdk-virtual-scroll-viewport [itemSize]="30.4" class="drop-down">
        <ul>
          @if (!noData) {
            <li>
        <mat-checkbox matRippleDisabled="true" (change)="selectedAll($event.checked)" [checked]="isAllSelected
          || selectedReceivingLabs.length == allReceivingLabs.length">All</mat-checkbox>
            </li>
          }
          <li *cdkVirtualFor="let list of filteredList;">
            <mat-checkbox (change)="selectField($event, list)" [disabled]="list.isDisabled" [checked]="list?.isSelected">
              {{list?.labSiteCode}}
            </mat-checkbox>
          </li>
          @if (noData) {
            <li class="no-record"><span>No records..</span></li>
          }
        </ul>
      </cdk-virtual-scroll-viewport>
      <footer>
        <button mat-button color="warn" type="button" class="clear" [disabled]="selectedReceivingLabs.length === 0"
        (click)="selectedReceivingLabs.length > 0 && clearAll(); receivingLabListCtrl.setValue('')">Clear All</button>
        <button mat-button color="primary" type="button" class="apply" [disabled]="selectedReceivingLabs.length === 0" (click)="applyFilter(); receivingLabListCtrl.setValue('')">Apply</button>
      </footer>
    </div>
  }
